// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yo9a","rootMobile":"styles_rootMobile__hB_tn"};